import ActiveSwitch from './ActiveSwitch'

export default ActiveSwitch
